import React, {
  Suspense,
} from 'react'

import PropTypes from 'prop-types'

import { useModalDialog } from '@termly-web/common'

import Styles from './styles.scss'


export default function ModalDialog({ ariaLabel, children, handleCancel }) {
  const {
    closedby,
    dialogRef,
    onCancel,
    onClose,
  } = useModalDialog({ handleCancel })

  // A lazy component in the content has to suspend to a boundary inside the
  // dialog. If it reaches one above the dialog instead, Preact takes the
  // dialog out of the document until the component loads, and a dialog that
  // isn't in the document can't be opened as a modal.
  return (
    <dialog
      aria-label={ ariaLabel }
      className={ Styles.root }
      closedby={ closedby }
      onCancel={ onCancel }
      onClose={ onClose }
      ref={ dialogRef }
    >
      <Suspense fallback={ null }>
        { children }
      </Suspense>
    </dialog>
  )
}

ModalDialog.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
  handleCancel: PropTypes.func,
}
